<div *ngIf="isLoggedIn; else notLoggedIn">
  <router-outlet></router-outlet>
</div>

<ng-template #notLoggedIn>
  Not logged in.
</ng-template>
